import React, { useEffect, useState } from 'react';

import { getPartnersList } from '../../services/api';
import EmptyMessage from '../FilterCategories/EmptyMessage';
import FilterCategories from '../FilterCategories/FilterCategories';
import useFilterCategoriesHook from '../FilterCategories/useFilterCategoriesHook';

import PartnerCard, { SC } from './PartnerCard';

const FilterPartners = ({ filters }) => {
  const [state, dispatch] = useFilterCategoriesHook();
  const { start, end, active, open, filterId } = state;
  const { categories } = { ...filters };
  const [allPartners, SetAllPartners] = useState({
    data: [],
    page: { prev: 0, next: null },
  });
  const [error, SetError] = useState(false);

  const getAllPartnersData = async ({ pageNumber }) => {
    try {
      const allPartnersData = await getPartnersList({
        pageNumber,
        filterId,
      });
      const { page, data } = allPartnersData;
      const mergedData = [...allPartners.data, ...data];

      if (allPartners.data.length > 0 && pageNumber === 1) {
        SetAllPartners(allPartnersData);
      } else {
        SetAllPartners({ data: mergedData, page });
      }
    } catch (e) {
      SetError(e);
    }
  };

  useEffect(() => {
    getAllPartnersData({ pageNumber: 1 });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterId]);

  return (
    <div className="text-center">
      <h2>All Partners</h2>
      <FilterCategories
        filterCategories={categories}
        active={active}
        open={open}
        dispatch={dispatch}
        type="mobile"
      />
      <FilterCategories
        filterCategories={categories}
        start={start}
        end={end}
        active={active}
        open={open}
        dispatch={dispatch}
        type="desktop"
      />
      {error && <p>{error}</p>}
      {allPartners.data?.length > 0 ? (
        <SC.PartnerWrapper>
          <div className="slider all">
            {allPartners.data?.map((partner) => {
              return <PartnerCard partner={partner} key={partner.id} />;
            })}
          </div>
        </SC.PartnerWrapper>
      ) : (
        <EmptyMessage type="partners" />
      )}
      {allPartners.page?.next && (
        <SC.LoadMore
          onClick={() =>
            getAllPartnersData({
              pageNumber: Number(allPartners.page?.prev) + 1,
            })
          }
          data-testid="load-more"
        >
          Load more
        </SC.LoadMore>
      )}
    </div>
  );
};

export default FilterPartners;
